/**
 * 侧栏抽屉状态 - AppLayout 提供, 子路由 (Conversation 等) 注入后可打开抽屉.
 *
 * 桌面端 (lg+) 侧栏常驻, 仅移动端走抽屉模式. 状态集中在 AppLayout,
 * 子视图通过 useSidebarDrawer() 拿到 openSidebar 即可触发滑入.
 */
import { inject, provide, type InjectionKey, type Ref } from 'vue'

export interface SidebarDrawer {
  open: Ref<boolean>
  openSidebar: () => void
  closeSidebar: () => void
}

export const SidebarDrawerKey: InjectionKey<SidebarDrawer> = Symbol('sidebarDrawer')

export function provideSidebarDrawer(ctx: SidebarDrawer): void {
  provide(SidebarDrawerKey, ctx)
}

export function useSidebarDrawer(): SidebarDrawer | undefined {
  return inject(SidebarDrawerKey, undefined)
}
